import { Star } from "lucide-react";

// Green / Orange / Red confidence scale
const MAP = {
  High: { color: "#16A34A", label: "High", desc: "Strong, high-confidence match" },
  Medium: { color: "#F59E0B", label: "Medium", desc: "Partial match, some inference" },
  Low: { color: "#EF4444", label: "Low", desc: "Weak / loose inference" },
};
const FILLED = { High: 3, Medium: 2, Low: 1 };

function norm(level) {
  return MAP[level] ? level : "Medium";
}

// Single coloured star — used for per-field confidence (sector / seniority / region)
export function ConfidenceBadge({ level, testId }) {
  const key = norm(level);
  const c = MAP[key];
  return (
    <span
      data-testid={testId}
      title={`${c.label} confidence — ${c.desc} (AI inferred)`}
      className="inline-flex items-center"
    >
      <Star className="w-3.5 h-3.5" style={{ color: c.color, fill: c.color }} strokeWidth={1.5} />
    </span>
  );
}

// 3-star rating — used for search relevance ("match")
export function MatchBadge({ level }) {
  const key = norm(level);
  const c = MAP[key];
  const filled = FILLED[key];
  return (
    <span
      className="inline-flex items-center gap-0.5"
      title={`${c.label} match — ${c.desc}`}
      data-testid="match-stars"
    >
      {[0, 1, 2].map((i) => (
        <Star
          key={i}
          className="w-4 h-4"
          strokeWidth={1.5}
          style={{
            color: i < filled ? c.color : "#334155",
            fill: i < filled ? c.color : "transparent",
          }}
        />
      ))}
    </span>
  );
}

export function InferredValue({ value, level, testId }) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-slate-200 text-sm">{value || "—"}</span>
      {value && <ConfidenceBadge level={level} testId={testId} />}
    </div>
  );
}

// Legend explaining the coloured-star scale
export function ConfidenceLegend({ className = "" }) {
  return (
    <div
      data-testid="confidence-legend"
      className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-slate-400 ${className}`}
    >
      <span className="text-slate-500 font-mono-niq uppercase tracking-wider text-[10px]">Confidence</span>
      {["High", "Medium", "Low"].map((k) => (
        <span key={k} className="inline-flex items-center gap-1.5">
          <Star className="w-3.5 h-3.5" strokeWidth={1.5} style={{ color: MAP[k].color, fill: MAP[k].color }} />
          <span className="text-slate-300">{MAP[k].label}</span>
          <span className="text-slate-500 hidden sm:inline">· {MAP[k].desc}</span>
        </span>
      ))}
    </div>
  );
}
